import Head from 'next/head';

import styles from './_NotFound.module.css';

export function NotFound(): JSX.Element {
	return (
		<>
			<Head>
				<title>404: Not Found | RCN Learn</title>
			</Head>

			<main className={styles.content}>
				<div className="padX padY">
					<a href="/">
						<img src="/icons/RcnLearnLogo.svg" loading="lazy" height={64} width={270} alt="RCN Learn logo" />
					</a>

					<h1 className="padYL">Page not found</h1>

					<a href="/" className="button pinkDark">
						Take me to RCN Learn
					</a>
				</div>
			</main>
		</>
	);
}
